module.exports = __webpack_public_path__ + "user-placeholder.ebbce5adc9b1f64c60caf966b4910a67.hashedasset.svg";